import jsonApiNormalizer from 'json-api-normalizer'
import reduxObjectBuild from 'redux-object'
import * as Lodash from 'lodash/fp'

import { AdapterContext, HttpCommand } from '../interfaces/base'
import { IStringAnyMap } from '../types/map'
import DI from '../app/di'

type NormalizeOptionsType = {
  camelizeKeys: boolean
  camelizeTypeValues: boolean
}

export const normalize = (input: any, opts?: NormalizeOptionsType) => {
  const normalized = jsonApiNormalizer(
    input,
    opts || {
      camelizeKeys: false,
      camelizeTypeValues: false,
    },
  )

  return normalized
}

export const build = reduxObjectBuild

export const buildFirst = (entities: IStringAnyMap, entity: string) => {
  if (entity in entities) {
    const ids = Object.keys(entities[entity])
    if (ids.length > 0) {
      return build(entities, entity, ids[0], { ignoreLinks: true })
    }

    return null
  }

  return null
}

export const buildAll = (
  entities: IStringAnyMap,
  entity: string,
  originalInput: any,
) => {
  const first = Lodash.isArray(originalInput.data) ? originalInput.data : []
  const second = Lodash.isArray(originalInput.included)
    ? originalInput.included
    : []
  const all = [...first, ...second].filter((e: any) => e.type === entity)

  if (entity in entities) {
    let ids = all.map((e) => e.id)

    const mapped = ids.map((id) => {
      return build(entities, entity, id, { ignoreLinks: true })
    })

    return mapped
  } else {
    return []
  }
}

export function encode<T>(
  contexts: AdapterContext<T>,
  entity: T,
  context = 'default',
) {
  if (context in contexts) {
    return contexts[context].encode(entity)
  } else {
    throw new Error(`Adapter context ${context} not present, cannot encode.`)
  }
}

export function decode<T>(
  contexts: AdapterContext<T>,
  data: any,
  context = 'default',
  options = {},
) {
  if (context in contexts) {
    const decoded = contexts[context].decode(data, options)
    return decoded
  }

  throw new Error(`Adapter context ${context} not present, cannot decode.`)
}

type DoHttpOptions = Partial<{
  throwOnError: boolean
  expectedErrorCodes?: number[]
}>

export const doHttp = async (target: HttpCommand, options?: DoHttpOptions) => {
  const { throwOnError = false, expectedErrorCodes = [] } = options || {}
  const http = DI.get('http')({ expectedErrorCodes })

  if ('data' in target) {
    try {
      const response = await http[target.method](
        target.url,
        target.data,
        target.config,
      )
      return response
    } catch (e: any) {
      if (!throwOnError) {
        return e.response
      } else {
        throw e
      }
    }
  } else {
    try {
      const response = await http[target.method](target.url, target.config)
      return response
    } catch (e: any) {
      if (!throwOnError) {
        return e.response
      } else {
        throw e
      }
    }
  }
}
